import { render, staticRenderFns } from "./SingleCard.vue?vue&type=template&id=4f2fc26e&scoped=true"
import script from "./SingleCard.vue?vue&type=script&lang=js"
export * from "./SingleCard.vue?vue&type=script&lang=js"
import style0 from "./SingleCard.vue?vue&type=style&index=0&id=4f2fc26e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2fc26e",
  null
  
)

export default component.exports